var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-1xl antialiased min-h-screen flex flex-col items-center justify-center p-2 font-mono overflow-y-auto text-white"},[_c('div',{staticClass:"bg-pattern w-full flex-grow"},[_c('router-view')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }